export default __webpack_public_path__ + "static/media/advanceFilter.b4e0ecec.svg";